module.exports = __webpack_public_path__ + "static/media/avatars_male_9.b712c66c.png";